import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Tags from './Tags'

const PostPreview = ({ post }) => (
  <div className="post-preview">
    <div className="post-preview-gap">
      <Link className="post-featured-image" to={post.fields.slug}>
        <GatsbyImage
          alt={post.frontmatter.title}
          image={post.frontmatter.featuredImage.childImageSharp.gatsbyImageData}
        />
      </Link>
      <div className="post-content">
        <Link className="post-title" to={post.fields.slug}>
          {post.frontmatter.title}
        </Link>
        <small>
          <span className="post-date">{post.frontmatter.date}</span>
        </small>
        <div className="post-excerpt">{post.frontmatter.excerpt}</div>
        <span className="post-tags">
          <Tags tags={post.frontmatter.tags} />
        </span>
      </div>
    </div>
  </div>
)

export default PostPreview
